
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as Yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(Yup);
import { Box, Button, Divider, Grid, Paper, Typography } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React, { useCallback, useContext, useState, useEffect } from 'react';
import { CheckboxField, SubmitButton, TextField } from '@microrealestate/commonui/components';
import config from '../config';
import ErrorPage from 'next/error';
import Link from '../components/Link';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import Page from '../components/Page';
import { StoreContext } from '../store';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { LogoAuthIllustration } from '../components/Illustrations';
import { useStyles } from '../styles/components/Auth.styles';
import { useGoogleLogin } from "@react-oauth/google";
import { setOrganizationId } from '../utils/fetch';
import { GoogleAnalytics, sendGAEvent } from '@next/third-parties/google';
import AppleAuthButton from '../components/AppleAuthButton';
const initialValues = {
    fullName: '',
    email: '',
    password: ''
};
const validationSchema = (t) => Yup.object().shape({
    fullName: Yup.string().required(t("FullName is a required filled")),
    email: Yup.string().email(t('Invalid email')).required(t("Email is a required filled")),
    password: Yup.string().min(6, t('Password must contain 6 or more characters with at least one of each: uppercase, lowercase, number and special')).minLowercase(1, t('Password must contain at least 1 lower case letter'))
        .minUppercase(1, t('Password must contain at least 1 upper case letter'))
        .minNumbers(1, t('Password must contain at least 1 number'))
        .minSymbols(1, t('Password must contain at least 1 special character')).required(t("Password is a required filled"))
});
const GoogleIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
  </svg>;
};
export default function SignUp({ pageError }) {
    const { t } = useTranslation('common');
    const store = useContext(StoreContext);
    const router = useRouter();
    const classes = useStyles();
    const [showInstallModal, setShowInstallModal] = useState(false);
    const signUp = async ({ fullName, email, password, isAgreeTerms }) => {
        try {
            const status = await store.user.signUp(fullName, email, password, isAgreeTerms);
            if (status !== 200) {
                switch (status) {
                    case 422:
                        store.pushToastMessage({
                            message: t('Some fields are missing'),
                            severity: 'error'
                        });
                        return;
                    case 409:
                        store.pushToastMessage({
                            message: t('This user is already registered'),
                            severity: 'error'
                        });
                        return;
                    default:
                        store.pushToastMessage({
                            message: t('Something went wrong'),
                            severity: 'error'
                        });
                        return;
                }
            }
            store.pushToastMessage({
                message: t('Send verification email'),
                severity: 'success'
            });
            sendGAEvent({ event: "conversion", value: "user_sign_up" });
            setTimeout(() => {
                router.push('/signin');
            }, 1500);
        }
        catch (error) {
            console.error(error);
            store.pushToastMessage({
                message: t('Something went wrong'),
                severity: 'error'
            });
        }
    };
    useEffect(() => {
        const userAgent = typeof window !== "undefined" ? navigator.userAgent || navigator.vendor || window.opera : "";
        if (/android/i.test(userAgent)) {
            setShowInstallModal(true);
        }
    }, []);
    //Google Login
    const signInWithGoogle = useGoogleLogin({
        onSuccess: async (googleData) => {
            sendGAEvent({ event: "conversion", value: "user_sign_up_google" });
            let access_token = googleData?.access_token;
            const response = await store.user.signInGoogle(access_token);
            handleLoginStatus(response.status, response.data?.message);
            // singupGoogle(access_token)
        },
        onError: error => {
            console.error("error in with current user");
        },
        // flow: "auth-code",
        prompt: "consent select_account",
        ux_mode: "popup",
        select_account: true,
        scope: "openid https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email"
    });
    // const singupGoogle = async (token) => {
    //   const status = await store.user.signInGoogle(token)
    //   try {
    //     if (status !== 200) {
    //       switch (status) {
    //         case 422:
    //           store.pushToastMessage({
    //             message: t('Some fields are missing'),
    //             severity: 'error',
    //           });
    //           return;
    //         case 401:
    //           store.pushToastMessage({
    //             message: t('Incorrect email or password'),
    //             severity: 'error',
    //           });
    //           return;
    //         case 403:
    //           store.pushToastMessage({
    //             message: t('Email not verified, please check your email'),
    //             severity: 'error',
    //           });
    //           return;
    //         case 409:
    //           store.pushToastMessage({
    //             message: t('Email has been registered with other provider'),
    //             severity: 'error',
    //           });
    //           return;
    //         default:
    //           store.pushToastMessage({
    //             message: t('Something went wrong'),
    //             severity: 'error',
    //           });
    //           return;
    //       }
    //     }
    //     await store.organization.fetch();
    //     if (store.organization.items.length) {
    //       if (!store.organization.selected) {
    //         store.organization.setSelected(
    //           store.organization.items[0],
    //           store.user
    //         );
    //       }
    //       setOrganizationId(store.organization.selected._id);
    //       router.push(
    //         `/dashboard`,
    //         undefined,
    //         {
    //           locale: store.organization.selected.locale,
    //         }
    //       );
    //       await store.subscription.fetchData()
    //     } else {
    //       router.push('/firstaccess');
    //     }
    //   } catch (error) {
    //     console.error(error);
    //     store.pushToastMessage({
    //       message: t('Something went wrong'),
    //       severity: 'error',
    //     });
    //   }
    // }
    const handleLoginStatus = useCallback(async (status, message) => {
        try {
            if (status !== 200) {
                switch (status) {
                    case 422:
                        store.pushToastMessage({
                            message: t('Some fields are missing'),
                            severity: 'error'
                        });
                        return;
                    case 401:
                        store.pushToastMessage({
                            message: t(message /*'Incorrect email or password'*/),
                            severity: 'error'
                        });
                        return;
                    case 403:
                        store.pushToastMessage({
                            message: t(message /*'Email not verified, please check your email'*/),
                            severity: 'error'
                        });
                        return;
                    case 409:
                        store.pushToastMessage({
                            message: t('Email method login is differ'),
                            severity: 'error'
                        });
                        return;
                    default:
                        store.pushToastMessage({
                            message: t('Something went wrong'),
                            severity: 'error'
                        });
                        return;
                }
            }
            await store.organization.fetch();
            if (store.organization.items.length) {
                if (!store.organization.selected) {
                    await store.organization.setSelected(store.organization.items[0], store.user);
                }
                setOrganizationId(store.organization.selected._id);
                // await fetchCoreData();
                if (store.organization.selected.isFirstConnection) {
                    router.push(`/onboarding`, undefined, {
                        locale: store.organization.selected.locale
                    });
                }
                else {
                    router.push(`/dashboard`, undefined, {
                        locale: store.organization.selected.locale
                    });
                }
                // await store.subscription.fetchData()
                await store.subscription.fetchByRealmId(store.organization.selected._id);
            }
            else {
                router.push('/firstaccess');
            }
        }
        catch (error) {
            console.error(error);
            store.pushToastMessage({
                message: t('Something went wrong'),
                severity: 'error'
            });
        }
    }, [router, store, t]);
    if (pageError) {
        return <ErrorPage statusCode={pageError.statusCode}/>;
    }
    if (store.organization.selected?.name) {
        router.push(`/dashboard`);
        return null;
    }
    async function fetchCoreData() {
        try {
            const results = await Promise.allSettled([
                store.dashboard.fetch(),
                store.property.fetch(),
                store.room.fetch(),
                store.tenant.fetch(),
            ]);
            const failures = results
                .map((r, i) => ({ r, i }))
                .filter(({ r }) => r.status === 'rejected');
            if (failures.length) {
                const names = ['dashboard', 'property', 'room', 'tenant'];
                failures.forEach(({ r, i }) => {
                    console.warn(`Fetch ${names[i]} failed:`, r.reason);
                });
            }
            else {
                console.log('Core data loaded: dashboard, property, room, tenant');
            }
        }
        catch (error) {
            console.warn('Could not fetch core data:', error);
        }
    }
    return (<Page maxWidth="lg">
      <GoogleAnalytics gaId='G-MLNFQBGYTM' debugMode/>
      <Box className={classes.box} mx={2} mb={5}>
        <Paper style={{ borderRadius: "10px" }}>
          <Grid container>
            <Grid style={{ backgroundColor: "#1f1f1f", borderRadius: "10px" }} item xs={12} md={6}>
              <Box className={classes.boxhero}>
                <Grid container>
                  <Grid item xs={12}>
                    <LogoAuthIllustration height={45} width={179}/>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant='h5' style={{ color: "white", fontWeight: "600" }}>
                      {t('Manage costs')}
                      <Typography variant='inherit' style={{ color: "#FFD140" }}> {t('easy')}</Typography> {t('and')}
                      <Typography variant='inherit' style={{ color: "#FFD140" }}> {t('fast')}</Typography>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className={classes.boxform}>
                <Typography style={{ fontWeight: "600" }} variant='h4'>{t('Sign up to {{APP_NAME}}', {
            APP_NAME: config.APP_NAME
        })}</Typography>
                <Formik initialValues={initialValues} validationSchema={validationSchema(t)} onSubmit={signUp}>
                  {({ values, isSubmitting }) => {
            return (<Form>
                        <TextField label={t('Full Name')} name="fullName"/>
                        <TextField label={t('Email Address')} name="email"/>
                        <TextField label={t('Password')} name="password" type="password" autoComplete="current-password"/>
                        <Box width="100%" my={2}>
                          <CheckboxField name="isAgreeTerms" label={<span>
                                Dengan klik tombol daftar, saya telah membaca dan menyetujui serta tunduk kepada{' '}
                                <Link href="https://superkos.id/terms-and-conditions/" target="_blank" rel="noopener noreferrer" color="blue" underline="none">
                                  Ketentuan Layanan SuperKos.
                                </Link>
                              </span>}/>
                        </Box>
                        <Box mt={4}>
                          <SubmitButton fullWidth label={!isSubmitting ? t('Agree & Join') : t('Joining')} disabled={values.isAgreeTerms ? false : true}/>
                        </Box>
                      </Form>);
        }}
                </Formik>
                <Divider style={{ height: 2, marginBlock: 12 }} variant='middle'/>
                <Box display="flex" flexDirection="column" sx={{ gap: 4 }}>
                  <Button fullWidth align="center" onClick={signInWithGoogle} style={{ color: "white", backgroundColor: "#1f1f1f" }} variant="contained" 
    // color="secondary"
    startIcon={<GoogleIcon />}>{t('Sign up by Google')}</Button>
                  <AppleAuthButton isSignUp={true} handleLoginStatus={handleLoginStatus}/>
                </Box>
              </Box>
              <Box mt={4}>
                <Box px={10} py={2}>
                  <Typography variant="body2">
                    {t('Already on {{APP_NAME}}?', {
            APP_NAME: config.APP_NAME
        })}{' '}
                    <Link href="/signin" data-cy="signin">
                      {t('Sign in')}
                    </Link>
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
      {showInstallModal && (<Box position="fixed" bottom={0} left={0} width="100%" zIndex={1300} bgcolor="#FFFFFF" boxShadow={3} py={2} px={1} display="flex" flexDirection="column" alignItems="center" style={{ borderTop: "1px solid #eee" }}>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography variant="body1" style={{ fontWeight: 500 }}>
              {t("Aplikasi tersedia di Google Play Store.")}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center" width="100%" mt={1}>
            <Button variant="contained" href="https://play.google.com/store/apps/details?id=com.skoslandord" target="_blank" rel="noopener noreferrer" style={{
                backgroundColor: "#FCCB06",
                color: "#0B0B0B",
                minWidth: 140
            }}>
              {t("Install aplikasi")}
            </Button>
            <Button style={{
                backgroundColor: "#D9D9D9",
                color: "#0B0B0B",
                marginLeft: 16
            }} onClick={() => setShowInstallModal(false)}>
              {t("Nanti saja")}
            </Button>
          </Box>
        </Box>)}
    </Page>);
}
SignUp.title = "Daftar";
async function getServerSideProps() {
    let props = {};
    if (!config.SIGNUP) {
        props = { pageError: { statusCode: 404 } };
    }
    return { props };
}

    async function __Next_Translate__getServerSideProps__1a15d0e82ae__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signup',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a15d0e82ae__ as getServerSideProps }
  